// Sidebar: grouped links with the permission each one needs
const sideMenuList = [
  {
    group: null,
    items: [{ title: "Dashboard", route: "/dashboard", icon: "bi-grid-1x2", perms: ["dashboard"] }],
  },
  {
    group: "Sales",
    items: [
      { title: "Orders", route: "/order-history", icon: "bi-bag-check", perms: ["orders"], badge: "to_fulfil" },
      { title: "Payments", route: "/payments", icon: "bi-credit-card-2-front", perms: ["payments"] },
      { title: "Customers", route: "/user-list", icon: "bi-people", perms: ["customers"] },
      { title: "Coupons", route: "/coupons", icon: "bi-ticket-perforated", perms: ["coupons"] },
      { title: "Reviews", route: "/reviews", icon: "bi-star", perms: ["reviews"], badge: "pending_reviews" },
    ],
  },
  {
    group: "Catalogue",
    items: [
      { title: "Products", route: "/product", icon: "bi-gem", perms: ["products"] },
      { title: "Inventory", route: "/inventory", icon: "bi-box-seam", perms: ["products"], badge: "low_stock" },
      { title: "Categories", route: "/category", icon: "bi-diagram-3", perms: ["categories"] },
    ],
  },
  {
    group: "Storefront",
    items: [
      { title: "Banners", route: "/banner", icon: "bi-image", perms: ["content"] },
      { title: "Homepage sections", route: "/home-title", icon: "bi-layout-text-window", perms: ["content"] },
      { title: "Category tiles", route: "/explore", icon: "bi-grid-3x2-gap", perms: ["content"] },
      { title: "FAQ", route: "/faq", icon: "bi-question-circle", perms: ["content"] },
      { title: "Policies", route: "/site-policy", icon: "bi-file-text", perms: ["content"] },
      { title: "Social links", route: "/social-media", icon: "bi-share", perms: ["content"] },
    ],
  },
  {
    group: "Settings",
    items: [
      { title: "Shipping", route: "/shipping", icon: "bi-truck", perms: ["settings"] },
      { title: "Store settings", route: "/settings", icon: "bi-sliders", perms: ["settings"] },
      { title: "Newsletter", route: "/subscribers", icon: "bi-envelope-paper", perms: ["customers", "settings"] },
      { title: "Staff & roles", route: "/role-list", icon: "bi-shield-lock", perms: ["owner"] },
    ],
  },
];
export default sideMenuList;
